"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "arienzo": {
    "2edea9b2": [{
      "hkey": "81afe039",
      "slug": "arienzo",
      "name": "Arienzo",
      "primary": true,
      "skipSearch": false
    }],
    "costa-di-rienzo": [{
      "hkey": "81afe039",
      "slug": "arienzo",
      "name": "Arienzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9ddf7284": [{
      "hkey": "81afe039",
      "slug": "arienzo",
      "name": "Arienzo",
      "primary": true,
      "skipSearch": false
    }],
    "crisci": [{
      "hkey": "81afe039",
      "slug": "arienzo",
      "name": "Arienzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "38b5994f": [{
      "hkey": "81afe039",
      "slug": "arienzo",
      "name": "Arienzo",
      "primary": true,
      "skipSearch": false
    }],
    "signorindico": [{
      "hkey": "81afe039",
      "slug": "arienzo",
      "name": "Arienzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;